import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";

import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { BackButton, Loader } from "@egovernments/digit-ui-react-components";

import EmpFileTransfer from "./EmpFileTransfer";
import DeactivateEmployee from "./DeactivateEmployee";

const InitiateTransfer = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const user = Digit.UserService.getUser();
  const authToken = user?.access_token || null;

  const [filteredRolesInfor, setFilteredRolesInfor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [fromSearchCompleted, setFromSearchCompleted] = useState({});
  const [toSearchCompleted, setToSearchCompleted] = useState({});

  const defaultValues = {};

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues,
  });
  const watchDepartment = watch("selectedDepartmentFrom");
  const watchAuthority = watch("selectedAuthorityFrom");
  const watchFromEmp = watch("employeeIdFrom");
  const watchToEmp = watch("employeeIdTo");
  // useEffect(() => {
  //   console.log("watchFromEMpEffect", watchFromEmp);
  // }, [watchFromEmp]);
  function getOtherRoleName(roles) {
    const otherRole = roles.find((role) => role.name.toLowerCase() !== "employee");
    console.log("fromGetOtherRoleName", otherRole);

    return otherRole ? otherRole.name : null;
  }
  // const selectedEmpRole = getOtherRoleName(watchFromEmp?.value?.roles || []);
  const getApplicationFlowForIndex = () => watchDepartment || "";

  const departmentList = [
    { value: "DA", label: "Development Authority" },
    { value: "AVP", label: "Awas Evam Vikas Parishad" },
  ];

  const { data: EmployeeTypes = {}, isLoadings } = Digit.Hooks.hrms.useHrmsMDMS(tenantId, "egov-hrms", "HRMSRolesandDesignation") || {};

  const { data: { BPA: { Organizations } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["Organizations"]);

  const daList = Organizations?.filter((item) => item.Type === "DA");
  const avpList = Organizations?.filter((item) => item.Type === "AVP");

  const filterDepartmentsList = (completeList) => {
    return completeList?.map((office) => ({
      value: office.Name,
      label: office.Name,
    }));
  };

  const getOfficesListForIndex = (currentApplicationFlow) => {
    return currentApplicationFlow === "DA" ? filterDepartmentsList(daList) : currentApplicationFlow === "AVP" ? filterDepartmentsList(avpList) : [];
  };

  const getTransferValue = (index, fieldName) => watch(`transferDetails.${index}.${fieldName}`);

  const handleEmployeeResponse = async (location1, location2) => {
    const result = location2?.includes(",") ? location2.split(",").pop().trim() : location2?.trim();
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
    };
    try {
      const response = await axios.post(`${Urls.hrms.UserJobdelegationEmployeeSearch}?location1=${location1}&location2=${result}`, payload);
      setEmployeeList(
        (response?.data?.user || []).map((employee) => ({
          id: employee?.uuid,
          name: employee?.name,
          userName: employee?.userName,
          currentRoles: employee?.roles,
        }))
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching employees", error);
      throw error;
    }
  };

  const handleFromSectionSearch = async (index) => {
    const authority = getTransferValue(index, "fromDepartmentId");
    const department = getTransferValue(index, "fromLocation1");
    if (!authority || !department) {
      alert("Select Authority and Department first");
      return;
    }
    try {
      setLoading(true);
      await handleEmployeeResponse(department, department);
      setFromSearchCompleted((prev) => ({ ...prev, [index]: true }));
    } catch (err) {
      console.error("FROM search error", err);
      alert("Failed to search employees for FROM section");
    } finally {
      setLoading(false);
    }
  };

  const handleToSectionSearch = async (index) => {
    const authority = getTransferValue(index, "toDepartmentId");
    const department = getTransferValue(index, "toLocation1");
    if (!authority || !department) {
      alert("Select Authority and Department first");
      return;
    }
    try {
      setLoading(true);
      await handleEmployeeResponse(department, department);
      setToSearchCompleted((prev) => ({ ...prev, [index]: true }));
    } catch (err) {
      console.error("TO search error", err);
      alert("Failed to search employees for TO section");
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
      JobDelegation: data.transferDetails.map((transfer) => ({
        departmentId: transfer.departmentId,
        currentLocation: transfer.location1,
        tenantId: transfer.districtCode,
        empId: transfer.empId,
        oldDesignationRole: transfer.oldDesignationRole,
        roles: transfer.roles.map((role) => ({
          code: role.code,
          name: role.name,
          description: role.description,
        })),
        location1: transfer.district,
        location2: transfer.area,
        ward: transfer.location3,
        startDate: transfer.startDate,
        endDate: transfer.endDate,
      })),
    };

    try {
      const response = await axios.post(`${Urls.hrms.UserJobdelegationSearch}`, payload);
      setOpenApplicantPopup(true);
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit form.");
    }
  };
  async function handleEmpSearch(authority) {
    if (!authority) {
      return;
    }
    setLoading(true);
    const location = watchDepartment === "DA" ? authority?.split(" ")[0] : authority?.split(",")[1]?.trim();
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
    };
    try {
      const response = await axios.post(`${Urls.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response?.data?.user);
      setEmployeeIdList(
        (response?.data?.user || []).map((employee) => ({
          label: String(`${employee?.userName} - ${employee?.name}`),
          value: String(`${employee?.userName} - ${employee?.name}`),
          name: String(`${employee?.userName} - ${employee?.name}`),
          payload: employee,
        }))
      );
      setLoading(false);
      return response.data;
      // console.log("responseFromEmpSearch", response?.data);
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }
  async function handleFileTransfer() {
    console.log("bothEmployees", watchFromEmp, watchToEmp);

    const filters = { oldEmpId: watchFromEmp?.value?.split("-")[0].trim() || "", newEmpId: watchToEmp?.value?.split("-")[0].trim() || "" };
    console.log("filtersFromtransfer", filters);
    if (filters.oldEmpId === "" || filters.newEmpId === "") {
      alert("Please select both Old Employee Id and New Employee Id");
      return;
    }
    if (filters.oldEmpId === filters.newEmpId) {
      alert("Old Employee Id and New Employee Id cannot be the same");
      return;
    }

    Digit.UserService.employeeFileTransfer(filters)
      .then((res) => {
        // Handle cases where API returns only status without body
        if (!res || res.status === 200 || res.status === 204 || res.success) {
          alert("Employee File Transfer Successful");
        } else {
          console.log("Unexpected Response:", res);
          alert("Employee File Transfer Failed");
        }
      })
      .catch((err) => {
        console.error("errorFromFileTransfer", err);
        alert("Employee File Transfer Failed");
      });
  }

  if (loading && isLoadings) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <React.Fragment>
      <BackButton />
      <EmpFileTransfer
        t={t}
        control={control}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        watch={watch}
        departmentList={departmentList}
        getOfficesListForIndex={getOfficesListForIndex}
        getApplicationFlowForIndex={getApplicationFlowForIndex}
        handleEmpSearch={handleEmpSearch}
        handleFileTransfer={handleFileTransfer}
        employeeIdList={employeeIdList}
      />
      <DeactivateEmployee
        t={t}
        control={control}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        watch={watch}
        departmentList={departmentList}
        getOfficesListForIndex={getOfficesListForIndex}
        getApplicationFlowForIndex={getApplicationFlowForIndex}
        handleFileTransfer={handleFileTransfer}
        getOtherRoleName={getOtherRoleName}
        trigger={trigger}
      />
    </React.Fragment>
  );
};

export default InitiateTransfer;
